import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { nanoid } from "nanoid";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { allSetUserByID } from "../../redux/handlers/manage/allSetUserByID.handler";
import { mstSysRole } from "../../redux/handlers/manage/mstSysRole.handler";
import { createSetUser, clearcreateSetUser } from "../../redux/handlers/manage/createSetUser.handler";
import { updateSetUser, clearupdateSetUser } from "../../redux/handlers/manage/updateSetUser.handler";
import { deletePromotion, cleardeletePromotion } from "../../redux/handlers/manage/deletePromotion.handler";
export function SetUser() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionRole = _useState6[0], setOptionRole = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), roleId = _useState7[0], setRoleId = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState8[0], setModalDel = _useState8[1];
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(allSetUserReducer.isFetching);
        if (allSetUserReducer.data) {
            var data = allSetUserReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var seen = new Set();
            var uniqueData = data.filter(function(ele) {
                var _ele_sysRole;
                var name = ele === null || ele === void 0 ? void 0 : (_ele_sysRole = ele.sysRole) === null || _ele_sysRole === void 0 ? void 0 : _ele_sysRole.sys_role_name;
                if (name && !seen.has(name)) {
                    seen.add(name);
                    return true;
                }
                return false;
            }).map(function(ele) {
                var _ele_sysRole, _ele_sysRole1;
                return {
                    value: ele === null || ele === void 0 ? void 0 : (_ele_sysRole = ele.sysRole) === null || _ele_sysRole === void 0 ? void 0 : _ele_sysRole.sys_role_id,
                    label: ele === null || ele === void 0 ? void 0 : (_ele_sysRole1 = ele.sysRole) === null || _ele_sysRole1 === void 0 ? void 0 : _ele_sysRole1.sys_role_name
                };
            });
            setOptionRole(_to_consumable_array(all).concat(_to_consumable_array(uniqueData)));
        }
    }, [
        allSetUserReducer
    ]);
    useEffect(function() {
        var result = filteredItems;
        // filter ตาม text
        if (filterText) {
            var text = filterText.toLowerCase();
            result = result.filter(function(item) {
                return item.sys_user_fullname && item.sys_user_fullname.toLowerCase().includes(text) || item.sys_user_username && item.sys_user_username.toLowerCase().includes(text) || item.sys_user_nname && item.sys_user_nname.toLowerCase().includes(text);
            });
        }
        // filter ตาม roleId
        if (roleId) {
            result = result.filter(function(item) {
                return item.sys_user_role_id === roleId;
            });
        }
        setRowData(result);
    }, [
        filterText,
        roleId,
        filteredItems
    ]);
    var columns = [
        {
            name: "username",
            selector: function(row) {
                return row.sys_user_username ? row.sys_user_username : "-";
            },
            center: "true"
        },
        {
            name: "ชื่อ-นามสกุล",
            selector: function(row) {
                return row.sys_user_fullname;
            },
            center: "true"
        },
        {
            name: "ชื่อเล่น",
            selector: function(row) {
                return row.sys_user_nname;
            },
            center: "true"
        },
        {
            name: "เบอร์โทร",
            selector: function(row) {
                return row.sys_user_phone || "-";
            },
            center: "true"
        },
        {
            name: "สิทธิ์การใช้งาน",
            selector: function(row) {
                return row.sysRole.sys_role_name;
            },
            center: "true"
        },
        {
            name: "วันที่แก้ไข",
            selector: function(row) {
                return row.sys_user_updated_at ? moment(row.sys_user_updated_at).format("DD/MM/YYYY") : "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.sys_user_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.sys_user_status == "Enable" && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.sys_user_status == "Disable" && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.sys_user_id;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Link, {
                        to: "/manage_user/manage/".concat(row.sys_user_id),
                        style: {
                            marginRight: 5
                        },
                        children: /*#__PURE__*/ _jsx(EditIcon, {
                            style: {
                                color: "#797A7A",
                                fontSize: 30,
                                borderRadius: 40,
                                background: "#E9E9E9",
                                padding: 5
                            }
                        })
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการผู้ใช้งาน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "จัดการผู้ใช้งาน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 7,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาสิทธิ์ผู้ใช้งาน"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาสิทธิ์ผู้ใช้งาน",
                                                    options: optionRole,
                                                    value: optionRole.find(function(opt) {
                                                        return opt.value === roleId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setRoleId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 5,
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "horizontal",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control me-3 mt-[13px]",
                                                    placeholder: "ค้นหาผู้ใช้งาน",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Link, {
                                                    className: "btn btn-dg w-[200px] mt-[13px]",
                                                    to: "/manage_user/manage",
                                                    children: "สร้างผู้ใช้งาน"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
export function SetUserManage() {
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState({}), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsMstSysRole = _useState1[0], setoptionsMstSysRole = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), formdisabled = _useState2[0], setFormdisabled = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), textsuccess = _useState3[0], setTextsuccess = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState("Enable"), 2), status = _useState5[0], setStatus = _useState5[1];
    var _useState6 = _sliced_to_array(useState(yup.object().shape({
        sys_user_fname: yup.string().required("กรุณากรอกชื่อ"),
        sys_user_lname: yup.string().required("กรุณากรอกนามสกุล"),
        sys_user_nname: yup.string().required("กรุณากรอกชื่อเล่น"),
        sys_user_phone: yup.number().typeError("กรุณากรอกเบอร์โทรให้ถูกต้อง").required("กรุณากรอกเบอร์โทร"),
        sys_user_username: yup.string().required("กรุณากรอกอีเมล"),
        password: yup.string().required("กรุณากรอกรหัสผ่าน").min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
        confirm_password: yup.string().required("กรุณากรอกยืนยันรหัสผ่าน").min(8, "ยืนยันรหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร").oneOf([
            yup.ref("password"),
            null
        ], "ยืนยันรหัสผ่านไม่ตรงกัน"),
        sys_user_role_id: yup.string().required("กรุณาเลือกสิทธิ์ผู้ใช้งาน")
    })), 2), schema = _useState6[0], setSchema = _useState6[1];
    var mstSysRoleReducer = useAppSelector(function(state) {
        return state.mstSysRoleReducer;
    });
    var createSetUserReducer = useAppSelector(function(state) {
        return state.createSetUserReducer;
    });
    var updateSetUserReducer = useAppSelector(function(state) {
        return state.updateSetUserReducer;
    });
    var allSetUserByIDReducer = useAppSelector(function(state) {
        return state.allSetUserByIDReducer;
    });
    useEffect(function() {
        dispatch(mstSysRole({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (dataID) {
            dispatch(allSetUserByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    useEffect(function() {
        setIsLoading(mstSysRoleReducer.isFetching || createSetUserReducer.isFetching || updateSetUserReducer.isFetching || allSetUserByIDReducer.isFetching);
        if (mstSysRoleReducer.data) {
            var isSelectOption = [];
            mstSysRoleReducer.data.data.map(function(ele) {
                return isSelectOption.push({
                    value: ele.sys_role_id,
                    label: ele.sys_role_name
                });
            });
            setoptionsMstSysRole(isSelectOption);
        }
        if (createSetUserReducer.data && !createSetUserReducer.isError) {
            setTextsuccess("สร้างผู้ใช้งาน");
            setModalsuccess(true);
            dispatch(clearcreateSetUser());
            navigate("/manage_user");
        }
        if (updateSetUserReducer.data && !updateSetUserReducer.isError) {
            setTextsuccess("แก้ไขผู้ใช้งาน");
            setModalsuccess(true);
            dispatch(clearupdateSetUser());
            navigate("/manage_user");
        }
        if (dataID) {
            if (allSetUserByIDReducer.data) {
                var promoData = allSetUserByIDReducer.data.data;
                var data = {
                    sys_user_id: promoData.sys_user_id,
                    sys_user_fname: promoData.sys_user_fname,
                    sys_user_lname: promoData.sys_user_lname,
                    sys_user_nname: promoData.sys_user_nname,
                    sys_user_phone: promoData.sys_user_phone,
                    sys_user_username: promoData.sys_user_username,
                    sys_user_role_id: promoData.sys_user_role_id
                };
                setSchema(yup.object().shape({
                    sys_user_fname: yup.string().required("กรุณากรอกชื่อ"),
                    sys_user_lname: yup.string().required("กรุณากรอกนามสกุล"),
                    sys_user_nname: yup.string().required("กรุณากรอกชื่อเล่น"),
                    sys_user_phone: yup.number().typeError("กรุณากรอกเบอร์โทรให้ถูกต้อง").required("กรุณากรอกเบอร์โทร"),
                    sys_user_username: yup.string().required("กรุณากรอกอีเมล").email("กรุณากรอกอีเมลให้ถูกต้อง"),
                    password: yup.string().min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
                    confirm_password: yup.string().when("password", {
                        is: function(password) {
                            return password && password.length > 0;
                        },
                        then: function(schema) {
                            return schema.required("กรุณากรอกยืนยันรหัสผ่าน").min(8, "ยืนยันรหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร").oneOf([
                                yup.ref("password"),
                                null
                            ], "ยืนยันรหัสผ่านไม่ตรงกัน");
                        },
                        otherwise: function(schema) {
                            return schema.notRequired();
                        }
                    }),
                    sys_user_role_id: yup.string().required("กรุณาเลือกสิทธิ์ผู้ใช้งาน")
                }));
                setStatus(promoData.sys_user_status);
                setFormdata(data);
            }
        }
    }, [
        mstSysRoleReducer,
        createSetUserReducer,
        updateSetUserReducer,
        allSetUserByIDReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการผู้ใช้งาน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: dataID ? "แก้ไขผู้ใช้งาน" : "สร้างผู้ใช้งาน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    console.log("formdataPayload", formdataPayload);
                    console.log("values", values);
                    if (!dataID) {
                        var create = _object_spread_props(_object_spread({}, values), {
                            sys_user_status: status
                        });
                        dispatch(createSetUser(create, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        var edit = _object_spread_props(_object_spread({}, values), {
                            sys_user_status: status
                        });
                        dispatch(updateSetUser(edit, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsx(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                        },
                        children: /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: formdisabled,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3 mb-4",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "pt-3 px-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "row gx-xl-4",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "ชื่อ",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "sys_user_fname",
                                                                        className: "form-control",
                                                                        placeholder: "ชื่อ",
                                                                        value: values.sys_user_fname,
                                                                        isInvalid: !!errors.sys_user_fname,
                                                                        onChange: function(e) {
                                                                            setFieldValue("sys_user_fname", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.sys_user_fname && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.sys_user_fname
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "นามสกุล",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "sys_user_lname",
                                                                        className: "form-control",
                                                                        placeholder: "นามสกุล",
                                                                        value: values.sys_user_lname,
                                                                        isInvalid: !!errors.sys_user_lname,
                                                                        onChange: function(e) {
                                                                            setFieldValue("sys_user_lname", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.sys_user_lname && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.sys_user_lname
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "ชื่อเล่น",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "sys_user_nname",
                                                                        className: "form-control",
                                                                        placeholder: "ชื่อเล่น",
                                                                        value: values.sys_user_nname,
                                                                        isInvalid: !!errors.sys_user_nname,
                                                                        onChange: function(e) {
                                                                            setFieldValue("sys_user_nname", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.sys_user_nname && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.sys_user_nname
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "เบอร์โทรศัพท์",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "sys_user_phone",
                                                                        className: "form-control",
                                                                        placeholder: "เบอร์โทรศัพท์",
                                                                        value: values.sys_user_phone,
                                                                        isInvalid: !!errors.sys_user_phone,
                                                                        onChange: function(e) {
                                                                            setFieldValue("sys_user_phone", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.sys_user_phone && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.sys_user_phone
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "อีเมล",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "sys_user_username",
                                                                        className: "form-control",
                                                                        placeholder: "อีเมล",
                                                                        value: values.sys_user_username,
                                                                        isInvalid: !!errors.sys_user_username,
                                                                        onChange: function(e) {
                                                                            setFieldValue("sys_user_username", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.sys_user_username && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.sys_user_username
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "รหัสผ่าน",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "password",
                                                                        name: "password",
                                                                        className: "form-control",
                                                                        placeholder: "รหัสผ่าน",
                                                                        value: values.password,
                                                                        isInvalid: !!errors.password,
                                                                        onChange: function(e) {
                                                                            setFieldValue("password", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.password && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.password
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "ยืนยันรหัสผ่าน",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "password",
                                                                        name: "confirm_password",
                                                                        className: "form-control",
                                                                        placeholder: "ยืนยันรหัสผ่าน",
                                                                        value: values.confirm_password,
                                                                        isInvalid: !!errors.confirm_password,
                                                                        onChange: function(e) {
                                                                            setFieldValue("confirm_password", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            errors.confirm_password && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.confirm_password
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "สิทธิ์การใช้งาน",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        as: "select",
                                                                        name: "sys_user_role_id",
                                                                        onChange: function(e) {
                                                                            setFieldValue("sys_user_role_id", e.value);
                                                                        },
                                                                        z: true,
                                                                        className: !!errors.sys_user_role_id ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                        options: optionsMstSysRole,
                                                                        placeholder: "เลือกสิทธิ์การใช้งาน",
                                                                        value: optionsMstSysRole.filter(function(item) {
                                                                            return item.value === values.sys_user_role_id;
                                                                        }),
                                                                        isInvalid: !!errors.sys_user_role_id
                                                                    })
                                                                ]
                                                            }),
                                                            errors.sys_user_role_id && /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2 text-danger",
                                                                children: errors.sys_user_role_id
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-12 col-md-1",
                                                        children: /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mt-2 pt-2 tc-10",
                                                            children: "สถานะ"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-12 col-md-3",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                    inline: true,
                                                                    type: "radio",
                                                                    id: "p-radio-1",
                                                                    label: "เปิดใช้งาน",
                                                                    checked: status == "Enable" ? true : false,
                                                                    className: "form-check-st-2 tc-7 mt-3",
                                                                    onChange: function() {
                                                                        setStatus("Enable");
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                    inline: true,
                                                                    type: "radio",
                                                                    id: "p-radio-2",
                                                                    label: "ปิดใช้งาน",
                                                                    checked: status == "Disable" ? true : false,
                                                                    className: "form-check-st-2 tc-7 mt-3",
                                                                    onChange: function() {
                                                                        setStatus("Disable");
                                                                    }
                                                                })
                                                            ]
                                                        }, "p-radio")
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3  mb-4",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3 d-flex ",
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                onClick: function(e) {
                                                    navigate("/manage_user");
                                                },
                                                className: "btn-st-6 me-3 btn ms-auto",
                                                children: "ยกเลิก"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "submit",
                                                className: "bnt btn-dg",
                                                onClick: function(e) {
                                                    handleSubmit();
                                                    e.preventDefault();
                                                },
                                                children: "บันทึก"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    });
                }
            })
        ]
    });
} // export function DelModel({
 //   modal,
 //   setModal,
 //   setTextsuccess,
 //   setModalsuccess,
 //   setIsLoading,
 //   setModalObj,
 //   modalObj,
 //   dataID,
 // }) {
 //   const navigate = useNavigate();
 //   const dispatch = useAppDispatch();
 //   const [id, setId] = useState(0);
 //   // const deletePromotionReducer = useAppSelector(
 //   //   (state) => state.deletePromotionReducer
 //   // );
 //   // useEffect(() => {
 //   //   setIsLoading(deletePromotionReducer.isFetching);
 //   //   if (deletePromotionReducer.data && !deletePromotionReducer.isError) {
 //   //     setTextsuccess("ลบสาขาสำเร็จ");
 //   //     setModalsuccess(true);
 //   //     dispatch(cleardeletePromotion());
 //   //     dispatch(
 //   //       allSetUser({
 //   //         modalObj,
 //   //         setModalObj,
 //   //       })
 //   //     );
 //   //     setModal((prev) => ({ ...prev, open: false }));
 //   //   }
 //   // }, [deletePromotionReducer]);
 //   useEffect(() => {
 //     if (modal.data != null) {
 //       const vul = modal.data;
 //       setId(vul.id);
 //     }
 //   }, [modal.data, modal.open]);
 //   // const onClickModel = () => {
 //   //   if (modal.typeData == "deletePromotion") {
 //   //     const data = {
 //   //       sys_user_id: id,
 //   //     };
 //   //     dispatch(deletePromotion(data, { modalObj, setModalObj }));
 //   //   }
 //   // };
 //   return (
 //     <div>
 //       {/* <div className="px-3 py-4">
 //         <div className="text-center fs-24 tc-5 my-4">คุณต้องการลบข้อมูลนี้</div>
 //         <div className="text-center fs-24 my-6">{modal.data?.name}</div>
 //         <div className="text-center mt-5">
 //           <button
 //             type="button"
 //             className="btn btn-st-6 me-3"
 //             onClick={() => setModal((prev) => ({ ...prev, open: false }))}
 //           >
 //             ยกเลิก
 //           </button>
 //           <button
 //             type="button"
 //             className="btn btn-dg"
 //             onClick={(e) => {
 //               onClickModel();
 //             }}
 //           >
 //             ยืนยัน
 //           </button>
 //         </div>
 //       </div> */}
 //     </div>
 //   );
 // }
